import { useQuery } from '@tanstack/react-query';
import { useApi } from '../api/client.js';

interface WhoAmI {
  tenantId: string;
  userId: string;
  roles: string[];
  region: string;
  correlationId: string;
}

export function WhoAmIPage(): JSX.Element {
  const api = useApi();
  const { data, error, isLoading } = useQuery<WhoAmI>({
    queryKey: ['whoami'],
    queryFn: () => api.fetch('/catalog/whoami'),
  });

  return (
    <>
      <header className="page-title">
        <div>
          <h1>Session</h1>
          <p className="page-title-subtitle">
            Identity, tenant scope, and role membership as resolved by the API middleware. This is
            the exact context every request is authorized against.
          </p>
        </div>
      </header>

      <div className="card" style={{ maxWidth: 720 }}>
        <div className="card-body">
          {isLoading && <div className="text-dim">Checking session…</div>}
          {error && (
            <div className="alert alert--danger">
              Could not resolve session. The token may have expired; reload the page.
            </div>
          )}
          {data && (
            <div className="stack">
              <FieldRow label="Tenant" value={data.tenantId} mono />
              <FieldRow label="User" value={data.userId} mono />
              <FieldRow label="Region" value={data.region} />
              <FieldRow label="Correlation ID" value={data.correlationId} mono />
              <div>
                <div className="field-label" style={{ marginBottom: 6 }}>
                  Roles
                </div>
                <div className="chip-group">
                  {data.roles.map((r) => (
                    <span key={r} className="chip chip--on">
                      {r}
                    </span>
                  ))}
                  {data.roles.length === 0 && (
                    <span className="text-mute text-sm">No roles assigned.</span>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

function FieldRow({
  label,
  value,
  mono,
}: {
  label: string;
  value: string;
  mono?: boolean;
}): JSX.Element {
  return (
    <div className="row" style={{ gap: 'var(--space-4)' }}>
      <div className="field-label" style={{ width: 140, marginBottom: 0 }}>
        {label}
      </div>
      <div className={mono ? 'text-mono' : 'text-sm'}>{value}</div>
    </div>
  );
}
